import React, { useState, useEffect } from 'react';
import { collection, query, getDocs, where } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { Loader2 } from 'lucide-react';

const Location = () => {
  const [situationImage, setSituationImage] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSituationImage = async () => {
      try {
        setLoading(true);
        
        // Търсим файл с име situaciq.jpg в медийната библиотека
        const q = query(collection(db, 'media'));
        const querySnapshot = await getDocs(q);
        
        let imageUrl = null;
        querySnapshot.docs.forEach(doc => {
          const data = doc.data();
          const fileName = data.name || '';
          
          if (fileName.toLowerCase().includes('situaciq')) {
            imageUrl = data.url;
          }
        });
        
        setSituationImage(imageUrl);
      } catch (error) {
        console.error('Грешка при зареждане на снимката:', error);
        // Fallback към статичната снимка
        setSituationImage('/images/image.png');
      } finally {
        setLoading(false);
      }
    };

    fetchSituationImage();
  }, []);

  return (
    <section className="py-20 bg-neutral-50" id="location">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="section-title">Локация</h2>
          <p className="text-neutral-600 max-w-2xl mx-auto">
            Отлична локация в близост до ключови обекти и транспортни връзки
          </p>
        </div>

        <div className="flex justify-center">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden max-w-4xl w-full">
            {loading ? (
              <div className="flex items-center justify-center h-96">
                <Loader2 className="w-8 h-8 animate-spin text-primary" />
              </div>
            ) : (
              <img
                src={situationImage || '/images/image.png'}
                alt="Карта на локацията - Сграда Molino"
                className="w-full h-auto"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;